"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectCustomer = void 0;
exports.selectCustomer = {
  en: "Please select a customer.",
  fr: "Veuillez sélectionner un client.",
  es: "Por favor seleccione un cliente."
};